import React from 'react'

interface CheckboxProps {
   checked: boolean
   onChange: () => void
   className?: string
   size?: 'sm' | 'md' | 'lg'
}

export const CheckBoxField: React.FC<CheckboxProps> = ({
   checked,
   onChange,
   className = '',
   size = 'md',
}) => {
   const sizeClasses = {
      sm: 'w-3 h-3',
      md: 'w-4 h-4',
      lg: 'w-5 h-5',
   }

   const checkmarkSizeClasses = {
      sm: 'w-2 h-2',
      md: 'w-3 h-3',
      lg: 'w-4 h-4',
   }

   return (
      <div
         className={`${
            sizeClasses[size]
         } rounded border flex items-center justify-center cursor-pointer ${
            checked ? 'bg-purple-600 border-purple-600' : 'border-gray-500'
         } ${className}`}
         onClick={(e) => {
            e.stopPropagation()
            onChange()
         }}
      >
         {checked && (
            <svg
               className={`${checkmarkSizeClasses[size]} text-white`}
               fill="currentColor"
               viewBox="0 0 20 20"
               xmlns="http://www.w3.org/2000/svg"
            >
               <path
                  fillRule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clipRule="evenodd"
               />
            </svg>
         )}
      </div>
   )
}
